import React from "react";
import { BallTriangle } from "react-loader-spinner";

const Loader = ({ minHeight = "50vh", height = "auto" }) => {
  return (
    <div
      style={{ minHeight, height }}
      className="h-100  w-100 d-flex align-items-center justify-content-center"
    >
      <BallTriangle
        height={100}
        width={100}
        radius={5}
        color="#4fa94d"
        ariaLabel="ball-triangle-loading"
        wrapperStyle={{}}
        wrapperClass="loaderStandard"
        visible={true}
      />
    </div>
  );
};

export default Loader;
